import { render, staticRenderFns } from "./PlanCardSkeleton.vue?vue&type=template&id=dcb30008&scoped=true"
import script from "./PlanCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PlanCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PlanCardSkeleton.vue?vue&type=style&index=0&id=dcb30008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb30008",
  null
  
)

export default component.exports